import React, { Fragment } from 'react'

import { Paragraph } from './styles/typography'
import TextUnderline from './components/TextUnderline'
import Space from './components/Space'
import Link from './components/Link'

export const getTeamMemberDataFromSlug = slug => team.find(d => d.slug === slug)

export const team = [
  {
    disabled: false,
    slug: 'anthony-wiktor',
    fullName: 'Anthony Wiktor',
    firstName: 'Anthony',
    position: 'Creative Director',
    quote: 'Time to shift brands from giving up to moving forward...',
    description: (
      <Fragment>
        <Paragraph>
          Competition runs hard in Anthony's veins. Given that he grew up in
          Chicago rooting for sports legends like Michael Jordan and Walter
          Payton, that's no surprise.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          Plus, "Wiktor" is the Polish pronunciation of "victor." So when it
          came to naming his new agency, he naturally latched onto Ad Victorem
          (from the Latin version of "to the victor belongs the spoils").
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          Anthony brings that competitive spirit to his branding and design
          work, leading to shelves full of awards, and being listed in Web
          Designer Magazine's "Hot 100" list twice.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          Case in point: Anthony's recent work for tech startup{' '}
          <Link to="/work/motiv-ring">
            <TextUnderline color="#bbb" top={0.85} height={[0.3, 0.8]}>
              Motiv
            </TextUnderline>
          </Link>{' '}
          won a Webby Award and helped generate the company's first thousand
          sales with almost zero advertising. His passion is helping challenger
          brands rise above the mainstream competition and deliver campaigns
          that connect, awe, and, most importantly, succeed.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          In addition to helping clients like ESPN and Netflix rise to victory
          against their competitors, Anthony shares his passion with future
          design professionals, leading creative workshops at USC’s Annenberg
          Digital Lounge, serving on the board of AIGA Los Angeles and as an
          expert panelist for the annual GlobalTrend Marketing Awards.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/anthonywiktor/',
      twitter: 'https://twitter.com/creativeanthony',
    },
  },
  {
    disabled: false,
    slug: 'freddy-nager',
    fullName: 'Freddy Tran Nager',
    firstName: 'Freddy',
    position: 'Strategy Director',
    quote: 'Stir the imagination and leave the competition shaken.',
    description: (
      <Fragment>
        <Paragraph>
          Over his 25+ years in marketing and media, Freddy has continuously
          sought out big, new challenges.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          At MCA Records in the 90's, he led one of the world's first commercial
          websites to a top rating in ZD-NET Magazine despite having a
          significantly smaller team and budget than the competition.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          Later, as a Sr. Copywriter at major ad agency Saatchi & Saatchi,
          Freddy led his creative team to multiple awards for groundbreaking
          digital media serving the Toyota account.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          When the first dotcom boom went bust, Freddy realized that the
          slickest creativity didn't matter without the right business models.
          To hone his strategic skills, he earned an MBA in Marketing &
          Entrepreneurship from the University of Southern California. (Freddy
          earned his undergrad degree from Harvard.)
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          Today, Freddy also teaches at USC as an Adjunct Professor, while
          developing strategies for a diverse array of clients, from luxury car
          brands to foreign startups to celebrity influencers.
        </Paragraph>
        <Space y={16} />
        <Paragraph>
          And he's still got his eye out for big, new challenges.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/freddyjnager/',
      twitter: 'https://twitter.com/AtomicTango',
    },
  },
  {
    disabled: false,
    slug: 'greg-nicpon',
    fullName: 'Greg Nicpon',
    firstName: 'Greg',
    position: 'Art Director',
    quote: 'Design without a business goal is simply art.',
    description: (
      <Fragment>
        <Paragraph>
          A specialist in brand identity, user interaction, and web design, Greg
          has amassed numerous awards: Webby, American Advertising, W3, Hermes,
          Dot Comm, Communicator, and Horizon Interactive. He’s also Ad
          Victorem’s resident team leader, showing rookie designers the way.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/gnicpon/',
      twitter: 'https://twitter.com/gnicpon',
    },
  },
  {
    disabled: false,
    slug: 'kajsa-olsson',
    fullName: 'Kajsa Olsson',
    firstName: 'Kajsa',
    position: 'Project Manager',
    quote: 'Synch or swim.',
    description: (
      <Fragment>
        <Paragraph>
          A former member of The University of Southern California Rowing Team,
          Kajsa now synchs with a diverse array of professionals to manage
          projects and produce media — skills she mastered in USC's MA in
          Communication Management program.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/kajsa-olsson/',
    },
  },
  {
    disabled: false,
    slug: 'sarah-dzida',
    fullName: 'Sarah Dzida',
    firstName: 'Sarah',
    position: 'UX Strategist',
    quote: 'Problem-seeking, not just problem-solving.',
    description: (
      <Fragment>
        <Paragraph>
          Sarah has lectured on User Experience (UX) at UCLA’s business school,
          USC, and the Art Center College of Design. With her MA in Creative
          Writing, she also brings a creative touch to strategy, and recently
          won multiple awards for a website that captured Lexus’ key brand
          principles: craftsmanship, innovation, and passion.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/sarahdzida/',
      twitter: 'https://twitter.com/DthroughZ',
    },
  },
  {
    disabled: false,
    slug: 'ralph-brown',
    fullName: 'Ralph D. Brown III',
    firstName: 'Ralph',
    position: 'Media Advisor',
    quote: 'From the Big Game to the big screen',
    description: (
      <Fragment>
        <Paragraph>
          A competitor on and off the field, Ralph played pro football for the
          Arizona Cardinals and New York Giants, and is a member of the Nevada
          Cornhuskers Hall of Fame. Now a broadcaster for Fox Sports, Ralph
          provides Ad Victorem with insights on the media and team strategies.
        </Paragraph>
      </Fragment>
    ),
  },
  {
    disabled: false,
    slug: 'diran-yanikian',
    fullName: 'Diran Yanikian',
    firstName: 'Diran',
    position: 'Technology Producer',
    quote: 'Web development isn’t rocket science – but we treat it like it is.',
    description: (
      <Fragment>
        <Paragraph>
          The founder of award-winning tech development agency Dirango, Diran is
          a Certified Civil Engineer who switched from designing $150 million
          worth of L.A. projects to developing highly complex websites and apps.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/diranyanikian/',
    },
  },
  {
    disabled: false,
    slug: 'maciej-leszczynski',
    fullName: 'Maciej Leszczyński',
    firstName: 'Maciej',
    position: 'Front-End Developer',
    quote: "Things aren't always #00000 and #FFFFF",
    description: (
      <Fragment>
        <Paragraph>
          One of Poland’s top developers, Maciej is regularly featured on
          Codepen, an online community for sharing inspiring web projects. He’s
          considered a “Creative Developer” who understands aesthetics while
          pushing the limits of web technology.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin:
        'https://www.linkedin.com/in/maciej-leszczy%C5%84ski-164b35116/',
      instagram: 'https://www.instagram.com/maciekmaciej/',
      codepen: 'https://codepen.io/asistapl/',
    },
  },
  {
    disabled: false,
    slug: 'kasia-marcinkiewicz',
    fullName: 'Kasia Marcinkiewicz',
    firstName: 'Kasia',
    position: 'Digital Designer',
    quote: 'Creativity is magical not magic.',
    description: (
      <Fragment>
        <Paragraph>
          Kasia is an artist and web developer who specializes in complex SVG
          animations and uses her "design eye" to bring the best out of the
          modern web using React, Javascript, HTML/CSS. Kasia is also a
          self-taught watercolorist and frequently trades her mouse for a
          paintbrush.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin:
        'https://www.linkedin.com/in/katarzyna-marcinkiewicz-432a1a15a/',
      instagram: 'https://www.instagram.com/taurikate/',
      codepen: 'https://codepen.io/KazikM/pens/popular/',
    },
  },
  {
    disabled: false,
    slug: 'ara-soudjian',
    fullName: 'Ara Soudjian',
    firstName: 'Ara',
    position: 'Video Director',
    quote: 'Telling your story in 120 seconds or less.',
    description: (
      <Fragment>
        <Paragraph>
          Ara has excelled at lean filmmaking for over 20 years, including music
          videos for Grammy winners, TV commercials for numerous brands, and
          camerawork for George Clooney’s Section 8 Productions. With his
          minimal crew of film-school grads, he regularly jets off to exotic
          locations on the fly (literally) and brings home multiple awards.
        </Paragraph>
      </Fragment>
    ),
    links: {
      linkedin: 'https://www.linkedin.com/in/ara-soudjian-779459112/',
    },
  },
  {
    disabled: false,
    slug: 'tina-quillen',
    fullName: 'Tina Quillen',
    firstName: 'Tina',
    position: 'Digital Art Director',
    quote: 'Design is not the solution, it’s the process.',
    description: (
      <Fragment>
        <Paragraph>
          Tina is an experienced and skilled creative visual communication
          designer with over a decade of developing simple meaningful solutions
          to complex business challenges in a variety of industries from real
          estate and hospitality to corporate and consumer brands.
        </Paragraph>
      </Fragment>
    ),
    links: {
      // linkedin: '',
    },
  },
  {
    disabled: false,
    slug: 'vince-robbins',
    fullName: 'Vince Robbins',
    firstName: 'Vince',
    position: 'Content Advisor',
    quote: 'Ideas come from curiosity.',
    description: (
      <Fragment>
        <Paragraph>
          Vince hails as Graphic Designer and Writer from NASA's Jet Propulsion
          Laboratory. When he’s not doing rocket science he serves as a Creative
          Content Advisor at Ad Victorem where he helps strategize, concept, and
          produce various digital and print marketing campaigns.
        </Paragraph>
      </Fragment>
    ),
    links: {
      // linkedin: '',
    },
  },
]

export default team
